import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames';
import { polyfill } from 'react-lifecycles-compat';

var Switch = /*#__PURE__*/function (_React$Component) {
  _inherits(Switch, _React$Component);

  var _super = _createSuper(Switch);

  function Switch() {
    var _this;

    _classCallCheck(this, Switch);

    _this = _super.apply(this, arguments);
    _this.state = {
      checked: _this.props.checked === undefined ? !!_this.props.defaultChecked : _this.props.checked
    };
    /**
     * 非受控时可以使用该值访问 input
     */

    _this.inputNode = null;

    _this.getInput = function (ref) {
      if (ref) {
        _this.inputNode = ref;
      }
    };

    _this.handleClick = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          loading = _this$props.loading,
          defaultChecked = _this$props.defaultChecked,
          checked = _this$props.checked,
          onChange = _this$props.onChange;

      if (disabled || readOnly || loading) {
        return;
      }

      var nextState = !_this.state.checked;

      if (defaultChecked !== undefined && checked === undefined) {
        // 非受控模式传入了 checked 则不改变状态，按照受控逻辑处理
        _this.setState({
          checked: nextState
        });
      }

      onChange(nextState);
    };

    return _this;
  }

  _createClass(Switch, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onText = _this$props2.onText,
          offText = _this$props2.offText,
          disabled = _this$props2.disabled,
          loading = _this$props2.loading,
          size = _this$props2.size,
          className = _this$props2.className,
          style = _this$props2.style;
      return /*#__PURE__*/React.createElement("div", {
        className: classnames('roo-switch', {
          'roo-switch-mini': size === 'mini',
          'roo-switch-loading': loading,
          disabled: disabled
        }, className),
        style: style,
        onClick: this.handleClick
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: this.state.checked,
        disabled: disabled,
        ref: this.getInput,
        readOnly: true
      }), /*#__PURE__*/React.createElement("span", {
        className: "roo-switch-checkbox"
      }, this.state.checked && onText ? /*#__PURE__*/React.createElement("span", null, onText) : null, !this.state.checked && offText ? /*#__PURE__*/React.createElement("span", null, offText) : null));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.checked !== undefined) {
        return {
          checked: nextProps.checked
        };
      }

      return {};
    }
  }]);

  return Switch;
}(React.Component);

Switch.rooName = 'RSwitch';
Switch.propTypes = {
  onText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  offText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['normal', 'mini']),
  checked: PropTypes.bool,
  loading: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  defaultChecked: PropTypes.bool
};
Switch.defaultProps = {
  onText: '',
  offText: '',
  disabled: false,
  loading: false,
  readOnly: false,
  size: 'normal',
  checked: undefined,
  defaultChecked: undefined,
  onChange: function onChange() {}
};
polyfill(Switch);
export default Switch;